import { Bounds } from "@/types/map";

export interface SearchParamFilters {
	coordinates?: { lat: number; lng: number };
	zoom?: number;
	selectedLocationId?: string;
	bounds?: Bounds[];
}

export function parseFiltersFromSearchParams(searchParams: URLSearchParams | undefined): SearchParamFilters {
	if (!searchParams) {
		return {};
	}

	let boundsParam = searchParams.get("bounds");
	let selectedLocationId = searchParams.get("selectedLocationId") || undefined;
	let centerParam = searchParams.get("center");
	let zoomParam = searchParams.get("zoom");

	let coordinates: { lat: number; lng: number } | undefined = undefined;

	if (centerParam) {
		const [lat, lng] = centerParam.split("-");
		const parsedLat = parseFloat(lat);
		const parsedLng = parseFloat(lng);

		if (!isNaN(parsedLat) && !isNaN(parsedLng)) {
			if (parsedLat >= -90 && parsedLat <= 90 && parsedLng >= -180 && parsedLng <= 180) {
				coordinates = {
					lat: parsedLat,
					lng: parsedLng,
				};
			}
		}
	}

	let zoom: number | undefined;
	if (zoomParam) {
		const parsedZoom = parseInt(zoomParam, 10);
		if (!isNaN(parsedZoom) && parsedZoom > 0 && parsedZoom <= 20) {
			zoom = parsedZoom;
		}
	}

	let bounds: Bounds[] | undefined;
	if (boundsParam) {
		const boundsValues = boundsParam.split("-");
		if (boundsValues.length === 4) {
			const [north, east, south, west] = boundsValues.map(Number);
			bounds = [{ north, east, south, west }];
		}
	}

	// Only return defined values to prevent undefined from overwriting existing values
	const result: SearchParamFilters = {};

	if (coordinates) result.coordinates = coordinates;
	if (zoom) result.zoom = zoom;
	if (selectedLocationId) result.selectedLocationId = selectedLocationId;
	if (bounds) result.bounds = bounds;

	return result;
}
